import { useState } from 'react';
import { Button, Input } from 'reactstrap';
import { EvidenceFile, HandleFileDescriptionFn } from '@g17eco/types/file';

interface ImageDescriptionProps {
  photo: EvidenceFile;
  handleFileDescriptionAdd?: HandleFileDescriptionFn;
  isReadOnly: boolean;
  className?: string;
}

export const FileDescription = ({
  photo,
  handleFileDescriptionAdd,
  isReadOnly,
  className = 'align-items-center',
}: ImageDescriptionProps) => {
  const [description, setDescription] = useState('');
  const path = 'path' in photo ? photo.path : photo.file.path;
  const isUpdate = 'path' in photo;
  if (photo.description) {
    return <span className='file-description text-ThemeTextMedium'>{photo.description}</span>;
  }

  if (isReadOnly) {
    return null;
  }

  return (
    <div className={`img-description h-100 gap-1 d-flex ${className}`}>
      <Input
        key='img-description'
        type='text'
        placeholder='Page reference if applicable'
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        bsSize='sm'
      />
      <Button
        color='primary'
        disabled={!description}
        onClick={() => handleFileDescriptionAdd?.({ path, description, isUpdate })}
        size='sm'
      >
        Add
      </Button>
    </div>
  );
};
